import { useState, useCallback } from 'react';
import quarkusApi from '../../../../api/quarkusApi';

// Cria (sem id) ou atualiza (com id) um documento do paciente.
// Payload: { title, contentJson, contentHtml }.
export function useSaveDocument() {
  const [isSaving, setSaving] = useState(false);

  const save = useCallback((patientId, documentId, document) => {
    setSaving(true);
    const config = { headers: { Authorization: sessionStorage.getItem('token') } };
    const request = documentId
      ? quarkusApi.put(`/patients/${patientId}/documents/${documentId}`, document, config)
      : quarkusApi.post(`/patients/${patientId}/documents`, document, config);
    return request.finally(() => setSaving(false));
  }, []);

  return { save, isSaving };
}
